var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ticket && _vm.ticket.orderId && "TicketTitle" == _vm.field
    ? _c(
        "span",
        [
          _c("TicketTitle", {
            staticStyle: {
              overflow: "hidden",
              "white-space": "nowrap",
              "text-overflow": "ellipsis"
            },
            attrs: {
              ticketTitle: _vm.ticket.orderTitle,
              ticketNo: _vm.ticket.orderId,
              target: "_blank"
            }
          })
        ],
        1
      )
    : _vm.ticket && _vm.ticket.orderId
    ? _c("span", [_vm._v(_vm._s(_vm.ticket[_vm.field]))])
    : _c("span", [_vm._v("没有")])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-017d2341", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-017d2341","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/UserLatestTicket.vue
// module id = 914
// module chunks = 75